/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DeviceHealthIssueCategory, EPlotType } from '../../../core/models';

@Component({
  selector: 'fm-health-status-tooltip',
  templateUrl: './health-status-tooltip.component.html',
  styleUrls: ['./health-status-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HealthStatusTooltipComponent implements OnChanges {
  @Input()
  public deviceHealthStatus: string;
  @Input()
  public deviceType: EPlotType;

  public healthCategoryCss: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.deviceHealthStatus) {
      this.healthCategoryCss = this._getHealthStatusCss();
    }
  }

  private _getHealthStatusCss(): string {
    return this.deviceHealthStatus.toUpperCase() == DeviceHealthIssueCategory.Critical
      ? 'health-status-section__header__critical'
      : this.deviceHealthStatus.toUpperCase() == DeviceHealthIssueCategory.Major
      ? 'health-status-section__header__major'
      : this.deviceHealthStatus.toUpperCase() == DeviceHealthIssueCategory.Moderate
      ? 'health-status-section__header__moderate'
      : '';
  }
}
